import { factory } from 'lbs-pi-platform-access/es/data-server/';
import { Store, stores } from '../stores/index';
import { CacheProvider } from 'shared/stores/core/CacheProvider';

export class DataStore {
  static install (Vue, {uScopeApi, bearerToken}) {
    const store = new Store(uScopeApi);

    // Inject data services into the store.
    const http = Vue.$services.resolve('http');
    const dataServer = factory(http, {bearerToken});

    store.resources.set('ANNOTATIONS', dataServer.annotations.annotationsProvider);
    store.resources.set('PDN', dataServer.annotations.pindropProvider);
    store.resources.set('IA_MACROS', dataServer.imageAnalysis.macroProvider);
    store.resources.set('IA_JOBS', dataServer.imageAnalysis.jobProvider);
    store.resources.set('IA_RESULTS', dataServer.imageAnalysis.resultProvider);
    store.resources.set('USER_RIGHTS', dataServer.user.userRightsProvider);
    store.resources.set('USER_CONFIG', dataServer.user.userConfigProvider);

    // Install the data stores themselves.
    store.use(CacheProvider);
    stores.forEach(s => store.use(s));

    // Expose the data provider to uScope and it's extensions
    uScopeApi.plugins.register({
      name: 'pi:platform-api',
      extends: 'uScope',
      factory: () => ({dataServer}) // Anticipating extending to support other services
    });

    // Make the store accessible.
    Vue.$store = Vue.prototype.$store = store;
    Vue.$dispatch = Vue.prototype.$dispatch = store.dispatcher.dispatch;
  }
}



// WEBPACK FOOTER //
// ./src/shared/services/DataStore.js